"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _round = _interopRequireDefault(require("lodash/round"));
var _styling = require("../utils/styling");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var getColWidth = function getColWidth(width) {
  var fraction = (0, _round["default"])(Number(width) / 12, 7);
  return "".concat(fraction * 100, "%");
};
var getColCss = function getColCss(width, mediaWidth) {
  if (!width) {
    return '';
  }
  var widthPercent = 'auto';
  var flexGrow = 1;
  if (width !== 'auto') {
    widthPercent = getColWidth(width);
    flexGrow = 0;
  }
  return (0, _styledComponents.css)(["@media (min-width:", "px){flex-basis:", ";flex-grow:", ";max-width:", ";}"], mediaWidth, function (props) {
    var _props$styles, _props$styles2;
    return (_props$styles = props.styles) !== null && _props$styles !== void 0 && _props$styles.flexBasis && mediaWidth <= ((_props$styles2 = props.styles) === null || _props$styles2 === void 0 ? void 0 : _props$styles2.tablet) ? props.flexBasis : widthPercent;
  }, flexGrow, function (props) {
    var _props$styles3, _props$styles4;
    return (_props$styles3 = props.styles) !== null && _props$styles3 !== void 0 && _props$styles3.maxWidth && mediaWidth <= ((_props$styles4 = props.styles) === null || _props$styles4 === void 0 ? void 0 : _props$styles4.mobile) ? props.maxWidth : widthPercent;
  });
};

/**
 * Basic grid item (poor man's Material-UI GridItem). Usage example:
 *
 * ```jsx
 * <Grid>
 *   <GridItem lg={2} md={3} sm={6}>Content</GridItem>
 * </Grid>
 * ```
 */
var GridItem = _styledComponents["default"].div.withConfig({
  displayName: "GridItem",
  componentId: "sc-1xc3vlu-0"
})(["box-sizing:border-box;padding:", ";", ""], function (props) {
  return (0, _styling.toPixels)(props.padding);
}, function (props) {
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", ""], getColCss(props.xs, 0), getColCss(props.sm, 577), getColCss(props.md, 768), getColCss(props.lg, 992), getColCss(props.xl, 1200));
});
GridItem.propTypes = {
  xs: _propTypes["default"].oneOf(['auto', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  sm: _propTypes["default"].oneOf(['auto', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  md: _propTypes["default"].oneOf(['auto', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  lg: _propTypes["default"].oneOf(['auto', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  xl: _propTypes["default"].oneOf(['auto', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  padding: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};
GridItem.defaultProps = {
  xs: 12,
  sm: undefined,
  md: undefined,
  lg: undefined,
  xl: undefined,
  padding: 10
};
var _default = GridItem;
exports["default"] = _default;
//# sourceMappingURL=GridItem.js.map